module.exports = __webpack_public_path__ + "img/ico-edit.672f574f.svg";